import { namespaces } from '@common'

export const namespace = namespaces.insurance.value
export const schema = 'planSchema'
export const backendDocType = 'Plan'
export const docPrivilege = 'insurance'
